import React, { useRef, useState } from "react";
import { MdAudiotrack } from "react-icons/md";
import { FaPlay, FaPause } from "react-icons/fa";
import { useAccessCard } from "../../ContextProvider/Accesscardprovider";

const Audiocard = () => {

  const { acode } = useAccessCard();
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [progress, setProgress] = useState({});
  const [isPlaying, setIsPlaying] = useState({});
  const audioRefs = useRef([]);

  const togglePlay = (index) => {
    if (currentAudioIndex !== null && currentAudioIndex !== index) {
      const prevAudio = audioRefs.current[currentAudioIndex];
      if (prevAudio) {
        prevAudio.pause();
        prevAudio.currentTime = 0;
      }

      setProgress((prev) => ({ ...prev, [currentAudioIndex]: 0 }));
      setIsPlaying((prev) => ({ ...prev, [currentAudioIndex]: false }));
    }

    const audio = audioRefs.current[index];

    if (audio.paused) {
      audio.play();
      setCurrentAudioIndex(index);
      setIsPlaying((prev) => ({ ...prev, [index]: true }));
    } else {
      audio.pause();
      setIsPlaying((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleProgress = (index) => {
    const audio = audioRefs.current[index];
    if (audio) {
      const progressPercent = (audio.currentTime / audio.duration) * 100;
      setProgress((prev) => ({ ...prev, [index]: progressPercent || 0 }));
    }
  };

  const handleSeek = (event, index) => {
    const newProgress = event.target.value;
    const audio = audioRefs.current[index];
    if (audio) { 
      audio.currentTime = (newProgress / 100) * audio.duration;
      setProgress((prev) => ({ ...prev, [index]: newProgress }));
    }
  };

  return (
    <div className="Enroll_course_container">
      <h3>Audio</h3>
      <div className="Enroll_course_inner_container">
        {acode.map((item, index) => (
          <div key={index}>
            <div className="Audio_Container">
              <div className="Audio_Container_first_div">
                <MdAudiotrack size={40} className="course_icon" />
              </div>
              <div>
                <div className="centered-container">
                  <span>{item.audio_title}</span>
                </div>
                <div className="audio-player">
                  <button className="audio-player-btn" onClick={() => togglePlay(index)}>
                    {isPlaying[index] ? <FaPause className="audio-player-icon" /> : <FaPlay className="audio-player-icon" />}
                  </button>
                  <input
                    type="range"
                    value={progress[index] || 0}
                    max="100"
                    onChange={(e) => handleSeek(e, index)}
                    style={{
                      background: `linear-gradient(to right, #09636e ${progress[index] || 0}%, #ddd ${progress[index] || 0}%)`,
                    }}
                  />
                  <audio
                    ref={(el) => (audioRefs.current[index] = el)}
                    src={item.audio_link}
                    onTimeUpdate={() => handleProgress(index)}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Audiocard;
